import React, { Component } from 'react';

class IconAddNote extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="12.291" height="15.364" viewBox="0 0 12.291 15.364"><path className="a" d="M13.682,3H7.536A1.534,1.534,0,0,0,6.008,4.536L6,16.827a1.534,1.534,0,0,0,1.529,1.536h9.226a1.541,1.541,0,0,0,1.536-1.536V7.609Zm1.536,10.755h-2.3v2.3H11.377v-2.3h-2.3V12.218h2.3v-2.3h1.536v2.3h2.3Zm-2.3-5.377V4.152l4.225,4.225Z" transform="translate(-6 -3)" fill="#164b90" /></svg>
        );
    }
}

export default IconAddNote;